import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class TeamsClosed extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      dados: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.botaoEdicaoNome = this.botaoEdicaoNome.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  
  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turmas/canceladas', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  botaoEdicao (cell, row) {
    var url = '/turma/editar/' + cell;

    var botao = (
      <Link className={'btn btn-primary btn-sm'} to={url}>
        <i className="fa fa-fw fa-pencil"></i>
      </Link>
    );

    return botao;
  }

  botaoEdicaoNome (cell, row) {
    var url = '/turma/editar/' + cell;
    var name = '';
    var self = this;
    Object.keys(this.state.dados).map(function(k) {
      if(cell === self.state.dados[k].id) {
        name = self.state.dados[k].name;
      }
    });
    var botao = (
      <Link to={url}>
        {name}
      </Link>
    );

    return botao;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Lista de turmas canceladas</h3>
      <Link to="/turma/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> Adicionar turma</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há turmas cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} hidden={true} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Código</TableHeaderColumn>
        
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicaoNome} dataSort={true} width='300' filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Turma</TableHeaderColumn>

        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Inicial</TableHeaderColumn>

        <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Final</TableHeaderColumn>

        <TableHeaderColumn dataField="number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Comunicado</TableHeaderColumn>

        <TableHeaderColumn dataField="presence" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Tipo de presença</TableHeaderColumn>

        <TableHeaderColumn dataField="type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Tipo?</TableHeaderColumn>

        {/*<TableHeaderColumn dataField="payment_status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Pagamento?</TableHeaderColumn>*/}

        <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='80'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default TeamsClosed;



// WEBPACK FOOTER //
// ./src/Components/Teams/TeamsClosed.js